export const PAGE_URLS = {
  CHAT_ROOM: '/ChatRoom/1',
  LOGIN: '/login',
};
